import { useMutation, useQueryClient } from "@tanstack/react-query";
import { replyToReview } from "../../api/bReviewsApi";

export const useReplyToReview = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data) => replyToReview(data),
    onSuccess: () => {
      // Invalidate reviews list to refetch with updated data
      queryClient.invalidateQueries({ queryKey: ["reviews-list"] });
      queryClient.invalidateQueries({ queryKey: ["dashboard-stats"] });
    },
  });
};
